import * as _ from 'lodash';
import collectionUtils from '../../../common/collection-utils';
import {splitArrayInNArraysByLength} from '../../../../serp/services/utils';
import {GEO_TYPES} from '../../../../serp/constants';

angular.module('cian.highwayBrowser').controller('HighwayBrowserCtrl', [
  '$scope',
  '$uibModalInstance',
  'HighwaysService',
  'RegionUtilsService',
  'selectedRegions',
  'geo',
  'directions',
  'fromMcadKm',
  'AnalyticsService',
  /**
   * @param {FilterItem} geo - гео-фильтр
   * @param {FilterItem} directions - фильтр направлений
   * @param {FilterItem} fromMcadKm - фильтр расстояния до МКАД
   */
    function ($scope,
              $uibModalInstance,
              HighwaysService,
              RegionUtilsService,
              selectedRegions,
              geo,
              directions,
              fromMcadKm,
              AnalyticsService) {
    this.directionMetaData = {
      'Белорусское': 'w',
      'Курское': 's',
      'Савеловское': 'n',
      'Рижское': 'nw',
      'Ярославское': 'ne',
      'Горьковское': 'e',
      'Ленинградское': 'nw',
      'Казанское': 'se',
      'Павелецкое': 'se',
      'Киевское': 'sw'
    };
    this.fromMcadKm = fromMcadKm;
    let highwaysByDirection, directionByHighwayId;
    let selectedHighways = _.filter(geo.value, {type: GEO_TYPES.HIGHWAY});

    // Utils

    const setHighways = highways => {
      selectedHighways = highways;
      collectionUtils.updateSubsetOfCollectionInPlace(
        geo.value,
        selectedHighways,
        [GEO_TYPES.HIGHWAY],
      );
    };

    const isDirectionSelected = direction => _.some(directions.value, {name: direction.name});

    const isHighwayItselfSelected = highway => selectedHighways.some(h => h.id === highway.id);

    const getParentDirection = highway => directionByHighwayId[highway.id];

    const selectHighway = highway => {
      if (!this.isInSelected(highway)) {
        setHighways(selectedHighways.concat(highway));
        // Проверяем, выбраны ли все шоссе в направлении
        const parentDirection = getParentDirection(highway);
        if (parentDirection.highways.every(h => isHighwayItselfSelected(h))) {
          this.toggleDirection(parentDirection);
        }
      }
    };

    const deselectHighway = highway => {
      if (this.isInSelected(highway)) {
        const parentDirection = getParentDirection(highway);

        if (isDirectionSelected(parentDirection)) {
          this.toggleDirection(parentDirection);

          // Выбираем все шоссе, кроме того, которое убираем
          setHighways(selectedHighways.concat(
            parentDirection.highways.filter(item => item.id != highway.id)
          ));
        } else {
          setHighways(selectedHighways.filter(item => item.id !== highway.id));
        }
      }
    };

    // Initialization

    this.isLoading = true;
    const region = RegionUtilsService.findRegionWithHighway(selectedRegions);
    if (region) {
      HighwaysService.getHighways(region.id).then(data => {
        // {{'Казанское': {1: true, 2, true}}, {'Рижское': {3: true}}}
        highwaysByDirection = data.reduce((memo, direction) => {
          memo[direction.name] = direction.highways.reduce((highways, highway) => {
            highways[highway.id] = true;
            return highways;
          }, {});
          return memo;
        }, {});

        directionByHighwayId = data.reduce((memo, direction) => {
          direction.highways.forEach(highway => memo[highway.id] = direction);
          return memo;
        }, {});

        this.columns = splitArrayInNArraysByLength(data, 'highways');
      }).finally(() => this.isLoading = false);
    }

    // Public methods

    this.isInSelected = highway => {
      return isDirectionSelected(getParentDirection(highway)) ||
        isHighwayItselfSelected(highway);
    };

    this.isMoscowOrMO = () => RegionUtilsService.isMoscowOrMO(selectedRegions);

    this.toggleHighway = highway => {
      if (this.isInSelected(highway)) {
        deselectHighway(highway);
      } else {
        selectHighway(highway);
      }
    };

    this.toggleDirection = direction => {
      if (isDirectionSelected(direction)) {
        _.remove(directions.value, {name: direction.name});
      } else {
        // Выключаем по одиночке все шоссе внутри направления и включаем направление целиком
        setHighways(selectedHighways.filter(h => !highwaysByDirection[direction.name][h.id]));
        directions.value.push(direction);
      }
    };

    this.save = () => {
      let highwaysCount = selectedHighways.length;
      const directionValues = directions.value;
      if (directionValues.length) {
        highwaysCount += directionValues.reduce((prev, curr) => {
          return prev + curr.highways.length
        }, 0);
      }
      AnalyticsService.trackCA('Listing', 'popup_highway_save', String(highwaysCount), {});
      $uibModalInstance.close();
    }
  }]);



// WEBPACK FOOTER //
// ./src/components/highway-browser/src/scripts/cian.highway-browser.ctrl.js